import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';

/**
 * Ensure `users/{userId}/collageForFriend/summary` lists this poster (for creator tracking).
 * @param {import('firebase/firestore').Firestore} db
 */
export async function registerCollageForFriendPoster(db, userId, posterId) {
  if (!userId || !posterId) return;
  const ref = doc(db, 'users', userId, 'collageForFriend', 'summary');
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    const raw = snap.exists() ? snap.data() : {};
    const collages = Array.isArray(raw.collages) ? raw.collages.map((c) => ({ ...c })) : [];
    const idx = collages.findIndex((c) => c && c.posterId === posterId);
    if (idx < 0) {
      collages.push({
        posterId,
        friendEmails: [],
        friendIgHandles: [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
    } else {
      collages[idx] = {
        ...collages[idx],
        updatedAt: serverTimestamp(),
      };
    }
    tx.set(ref, { collages, updatedAt: serverTimestamp() }, { merge: true });
  });
}

/**
 * Append a friend email or IG handle to the collage entry (deduped).
 * @param {import('firebase/firestore').Firestore} db
 */
export async function appendCollageForFriendContact(db, userId, posterId, { friendEmail, friendIgHandle } = {}) {
  if (!userId || !posterId) return;
  const ref = doc(db, 'users', userId, 'collageForFriend', 'summary');
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    const raw = snap.exists() ? snap.data() : {};
    let collages = Array.isArray(raw.collages) ? raw.collages.map((c) => ({ ...c })) : [];
    let idx = collages.findIndex((c) => c && c.posterId === posterId);
    if (idx < 0) {
      collages.push({
        posterId,
        friendEmails: [],
        friendIgHandles: [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      idx = collages.length - 1;
    }
    const entry = { ...collages[idx] };
    entry.friendEmails = Array.isArray(entry.friendEmails) ? [...entry.friendEmails] : [];
    entry.friendIgHandles = Array.isArray(entry.friendIgHandles) ? [...entry.friendIgHandles] : [];
    if (friendEmail) {
      const low = String(friendEmail).trim().toLowerCase();
      if (low && !entry.friendEmails.includes(low)) entry.friendEmails.push(low);
    }
    if (friendIgHandle) {
      const h = String(friendIgHandle).trim().replace(/^@/, '');
      if (h && !entry.friendIgHandles.includes(h)) entry.friendIgHandles.push(h);
    }
    entry.updatedAt = serverTimestamp();
    collages[idx] = entry;
    tx.set(ref, { collages, updatedAt: serverTimestamp() }, { merge: true });
  });
}
